/**
 * 门户返回默认配置数据
 */
import { mockData1, mockData2 } from "./mockData"
import { simpleDeepClone } from "@/utils"

export const home = [
  {
    styleId:1,
    selectOptions: simpleDeepClone(mockData1),
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(123,123,125,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "titleBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "fontSize": 14,
    "lineMargin": 12,
    "columnMargin": 18,
    "groupMargin":8,
    "textLimitLines": 2,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "defaultBgColorIsThemeColor": false,
    "defaultBgColor": "rgb(255, 255, 255)",
    "titleFontFamily": "sans-serif",
    "titleFontSize":14,
    "titleFontWeight": 600,
    "titleFontStyle": "normal",
    "titleTextDecoration": "none",
    "titleLineHeight": 32,
    "titlePadding": 0,
    "titleWidth": 80,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 4,
    "activeBorderTopLeftRadius": 4,
    "activeBorderTopRightRadius": 4,
    "activeBorderBottomRightRadius": 4,
    "activeBorderBottomLeftRadius": 4,
    "titleLineHeightType": "px",
    "titleContentHasLimitRadio": "字数",
    "titleWidthAuto": false,
    "titleTextLimit": true,
    "titleTextLimitCount": 4,
    "arrangeType": "horizontal",
    "titleTextAlign": "justify",
    "lineHeightType": "px",
    "contentHasLimitRadio": "字数",
    "hoverLineHeightType": "px",
    "activeLineHeightType": "px",
    "activeShowBorder": false,
    "titleHeightAuto": false,
    "titleHeight": "0.16667rem"
  },
  {
    styleId:2,
    selectOptions: simpleDeepClone(mockData1),
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "hoverBoxShadowBlur": [],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeColor": {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(255,255,255,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255,255,255,1)"
    },
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "fontSize": 14,
    "lineMargin": 12,
    "columnMargin": 18,
    "moreFilter": false,
    "textLimitLines": 1,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 20,
    "activeBorderTopLeftRadius": 20,
    "activeBorderTopRightRadius": 20,
    "activeBorderBottomRightRadius": 20,
    "activeBorderBottomLeftRadius": 20,
    "activeLineHeightType": "px",
    "lineHeightType": "px",
    "contentHasLimitRadio": "字数",
    "hoverLineHeightType": "px",
    "activeShowBorder": false,
    "showMaxHeight": false,
    "showMinHeight": false
  },
  {
    styleId:3,
    model: "tree",
    selectOptions: [],
    filterOptions: simpleDeepClone(mockData2),
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(123,123,125,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "titleBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "fontSize": 14,
    "textAlign": "left",
    "lineMargin": 12,
    "columnMargin": 18,
    "moreFilter": "",
    "textLimitLines": 1,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "titleFontWeight": 600,
    "titleLineHeight": 32,
    "titleTextLimitLines": 1,
    "titleWidth": 80,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 4,
    "activeBorderTopLeftRadius": 4,
    "activeBorderTopRightRadius": 4,
    "activeBorderBottomRightRadius": 4,
    "activeBorderBottomLeftRadius": 4,
    "titleLineHeightType": "px",
    "titleContentHasLimitRadio": "字数",
    "titleTextAlign": "left",
    "titleTextLimit": true,
    "lineHeightType": "px",
    "contentHasLimitRadio": "行数",
    "hoverLineHeightType": "px",
    "activeLineHeightType": "px",
    "activeShowBorder": false,
  }
]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{}]

/**
 * app返回默认配置数据
 */
export const appHome = [
  {
    styleId:1,
    moreFilter: true,
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(123,123,125,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "titleBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "fontSize": 14,
    "lineMargin": 12,
    "columnMargin": 18,
    "groupMargin":8,
    "textLimitLines": 2,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "defaultBgColorIsThemeColor": false,
    "defaultBgColor": "rgb(255, 255, 255)",
    "titleFontFamily": "sans-serif",
    "titleFontSize":14,
    "titleFontWeight": 600,
    "titleFontStyle": "normal",
    "titleTextDecoration": "none",
    "titleLineHeight": 32,
    "titlePadding": 0,
    "titleWidth": 80,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 4,
    "activeBorderTopLeftRadius": 4,
    "activeBorderTopRightRadius": 4,
    "activeBorderBottomRightRadius": 4,
    "activeBorderBottomLeftRadius": 4,
    "titleLineHeightType": "px",
    "titleContentHasLimitRadio": "字数",
    "titleWidthAuto": false,
    "titleTextLimit": true,
    "titleTextLimitCount": 4,
    "arrangeType": "horizontal",
    "titleTextAlign": "justify",
    "lineHeightType": "px",
    "contentHasLimitRadio": "字数",
    "hoverLineHeightType": "px",
    "activeLineHeightType": "px",
    "activeShowBorder": false,
    "titleHeightAuto": false,
    "titleHeight": "0.16667rem"
  },
  {
    styleId:2,
    moreFilter: false,
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "hoverBoxShadowBlur": [],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeColor": {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(255,255,255,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255,255,255,1)"
    },
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "fontSize": 14,
    "lineMargin": 12,
    "columnMargin": 18,
    "textLimitLines": 1,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 20,
    "activeBorderTopLeftRadius": 20,
    "activeBorderTopRightRadius": 20,
    "activeBorderBottomRightRadius": 20,
    "activeBorderBottomLeftRadius": 20,
    "activeLineHeightType": "px",
    "lineHeightType": "px",
    "contentHasLimitRadio": "字数",
    "hoverLineHeightType": "px",
    "activeShowBorder": false,
    "showMaxHeight": false,
    "showMinHeight": false
  },
  {
    styleId:3,
    moreFilter: "tree",
    model: "tree",
    filterOptions: simpleDeepClone(mockData2),
    "hoverBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(123,123,125,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "background": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "titleBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "fontSize": 14,
    "textAlign": "left",
    "lineMargin": 12,
    "columnMargin": 18,
    "textLimitLines": 1,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 18,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 18,
    "titleFontWeight": 600,
    "titleLineHeight": 32,
    "titleTextLimitLines": 1,
    "titleWidth": 80,
    "hoverFontWeight": 600,
    "hoverColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 4,
    "activeBorderTopLeftRadius": 4,
    "activeBorderTopRightRadius": 4,
    "activeBorderBottomRightRadius": 4,
    "activeBorderBottomLeftRadius": 4,
    "titleLineHeightType": "px",
    "titleContentHasLimitRadio": "字数",
    "titleTextAlign": "left",
    "titleTextLimit": true,
    "lineHeightType": "px",
    "contentHasLimitRadio": "行数",
    "hoverLineHeightType": "px",
    "activeLineHeightType": "px",
    "activeShowBorder": false,
  },
  {
    styleId:4,
    filterOptions: simpleDeepClone(mockData1),
    "sureButton": {
      "content": "确定",
      "width": 160,
      "height": 40,
      "left": 218,
      "top": 5,
      "lineHeight": 40,
      "bgColorIsThemeColor": true,
      "borderBottomLeftRadius": 8,
      "borderBottomRightRadius": 8,
      "borderTopLeftRadius": 8,
      "borderTopRightRadius": 8,
      "borderTypeFlag": 2,
      "color": "rgba(255,255,255,1)",
      "fontSize": 15
    },
    "labelBoxBackground": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": ""
      }
    ],
    "titleActiveResInfo": {},
    "subFilterBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231,231,233,1)",
            0
          ],
          [
            "rgba(255,255,255,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231,231,233,1)",
      "type": "color",
      "label": "颜色"
    },
    "resetButton": {
      "content": "重置",
      "width": 160,
      "height": 40,
      "left": 40,
      "top": 5,
      "lineHeight": 38,
      "bgColor": "rgba(255,255,255,1)",
      "borderBottomLeftRadius": 8,
      "borderBottomRightRadius": 8,
      "borderTopLeftRadius": 8,
      "borderTopRightRadius": 8,
      "borderTypeFlag": 2,
      "borderIsThemeColor": true,
      "fontSize": 15,
      "showBorder": true,
      "borderWidth": 1,
      "borderStyle": "solid",
      "textIsThemeColor": true
    },
    "labelResInfo": {},
    "titleActiveColor": {
      "data": {
        "stops": [
          [
            "#2B67FF",
            0
          ],
          [
            "#2B67FF",
            1
          ]
        ],
        "angle": 0
      },
      "color": "#2B67FF"
    },
    "labelIconColor": {
      "data": {
        "stops": [
          [
            "#999999",
            0
          ],
          [
            "#999999",
            1
          ]
        ],
        "angle": 0
      },
      "color": "#999999"
    },
    "titleActiveIconColor": {
      "data": {
        "stops": [
          [
            "rgba(43, 103, 255, 1)",
            0
          ],
          [
            "rgba(43, 103, 255, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(43, 103, 255, 1)"
    },
    "titleResInfo": {},
    "subMenuConfig": [
      {
        "styleId": 1
      }
    ],
    "activeColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(255,255,255,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "background": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgb(255, 255, 255)"
      }
    ],
    "activeBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,1)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,1)"
      }
    ],
    "titleActiveBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231, 231, 233, 1)",
            0
          ],
          [
            "rgba(231, 231, 233, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231, 231, 233, 1)"
    },
    "subFilterBackground": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgb(255, 255, 255)"
      }
    ],
    "color": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(46,46,48,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleIconColor": {
      "data": {
        "stops": [
          [
            "rgba(0, 0, 0, 0.4)",
            0
          ],
          [
            "rgba(0, 0, 0, 0.4)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0, 0, 0, 0.4)"
    },
    "titleColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "rgba(123,123,125,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "titleActiveBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(3,89,181,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(3,89,181,0)"
      }
    ],
    "subFilterDialogBackground": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(0,0,0,0.3)"
      }
    ],
    "titleBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231, 231, 233, 1)",
            0
          ],
          [
            "rgba(231, 231, 233, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231, 231, 233, 1)"
    },
    "labelColor": {
      "data": {
        "stops": [
          [
            "rgba(0,0,0,0.8)",
            0
          ],
          [
            "7B7B7D",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(0,0,0,0.8)",
      "type": "color",
      "label": "颜色"
    },
    "defaultBackground": [
      {
        "data": {
          "stops": [
            [
              "rgba(243,243,246,0)",
              0
            ],
            [
              "rgba(246,206,1,1)",
              1
            ]
          ],
          "angle": 0
        },
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgba(243,243,246,0)"
      }
    ],
    "labelBackground": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "#FFFFFF"
      }
    ],
    "titleBackground": [
      {
        "type": "color",
        "label": "颜色",
        "isThemeColor": false,
        "color": "rgb(255, 255, 255)"
      }
    ],
    "padding": 16,
    "paddingTop": 16,
    "paddingRight": 16,
    "paddingLeft": 16,
    "paddingBottom": 16,
    "fontSize": 14,
    "moreFilter": false,
    "defaultPaddingTop": 6,
    "defaultPaddingRight": 12,
    "defaultPaddingBottom": 6,
    "defaultPaddingLeft": 12,
    "defaultBgColor": "#F3F4F5",
    "titleFontSize": 14,
    "titleLineHeight": 24,
    "titlePaddingTypeFlag": 2,
    "titlePaddingTop": 4,
    "titlePaddingRight": 12,
    "titlePaddingBottom": 4,
    "titlePaddingLeft": 12,
    "titleBorderRadius": 4,
    "titleBorderTopLeftRadius": 4,
    "titleBorderTopRightRadius": 4,
    "titleBorderBottomLeftRadius": 4,
    "titleBorderBottomRightRadius": 4,
    "titleBorderWidth": 1,
    "titleContentHasLimit": false,
    "hoverLineHeight": 36,
    "hoverColor": "#FFFFFF",
    "hoverBorderRadius": 20,
    "hoverBorderTopLeftRadius": 20,
    "hoverBorderTopRightRadius": 20,
    "hoverBorderBottomRightRadius": 20,
    "hoverBorderBottomLeftRadius": 20,
    "hoverBgColorIsThemeColor": true,
    "activeFontSize": 14,
    "activeFontWeight": 600,
    "activeColorIsThemeColor": true,
    "activeBorderRadius": 4,
    "activeBorderTopLeftRadius": 4,
    "activeBorderTopRightRadius": 4,
    "activeBorderBottomRightRadius": 4,
    "activeBorderBottomLeftRadius": 4,
    "activeBorderWidth": 0,
    "model": "filter",
    "filterAlignmentType": "left",
    "filterMargin": 16,
    "titleWidthAuto": true,
    "titleTitleIconShow": true,
    "titleIconSrc": "5CB4CFFC9CE56FF2",
    "titleIconType": "icon",
    "titleIconPosition": "right",
    "titleIconWidth": 16,
    "titleIconMargin": 2,
    "titleIconColorIsThemeColor": false,
    "titleBorderShow": true,
    "titleActiveFontFamily": "sans-serif",
    "titleActiveFontSize": 14,
    "titleActiveFontWeight": 400,
    "titleActiveFontStyle": "normal",
    "titleActiveTextDecoration": "none",
    "titleActiveLineHeight": 24,
    "titleActiveLetterSpacing": 0,
    "titleActiveWritingMode": "horizontal-tb",
    "titleActiveTextAlign": "center",
    "titleActiveTextIsThemeColor": true,
    "titleActiveBgColorIsThemeColor": false,
    "titleActiveBgColor": "rgb(255, 255, 255)",
    "titleActiveBorderShow": true,
    "titleActiveBorderStyle": "solid",
    "titleActiveBorderIsThemeColor": true,
    "titleActiveBorderWidth": 1,
    "titleActiveBorderTypeFlag": 2,
    "titleActiveBorderRadius": 4,
    "titleActiveBorderTopLeftRadius": 4,
    "titleActiveBorderTopRightRadius": 4,
    "titleActiveBorderBottomRightRadius": 4,
    "titleActiveBorderBottomLeftRadius": 4,
    "titleActiveTitleIconShow": true,
    "titleActiveIconSrc": "33e01f3f28721111ed0b1a4237dce25be78f",
    "titleActiveIconType": "icon",
    "titleActiveIconPosition": "right",
    "titleActiveIconWidth": 16,
    "titleActiveIconMargin": 2,
    "titleActiveIconColorIsThemeColor": true,
    "subFilterBgColorIsThemeColor": false,
    "subFilterBgColor": "rgb(255, 255, 255)",
    "labelIconType": "icon",
    "labelIconSrc": "341a90dc58721111ed0b1a44515d233ecc01",
    "subMenuHeightAuto": true,
    "subMenuHeight": 40,
    "subFilterHeightAuto": false,
    "subFilterHeight": 200,
    "labelBoxPaddingRight": 16,
    "labelBoxPaddingLeft": 16,
    "labelBgColor": "#FFFFFF",
    "labelFontSize": 13,
    "labelIconWidth": 12,
    "labelIconMargin": 8,
    "filterBottomHeight": 50,
    "labelLineHeight": 24,
    "labelPaddingLeft": 10,
    "labelPaddingRight": 10,
    "titleContentHasLimitRadio": "字数",
    // "reload": true,
    "menuRowContent": 3,
    "subFilterBorderTopLeftRadius": 0,
    "subFilterBorderTopRightRadius": 0,
    "subFilterBorderBottomLeftRadius": 12,
    "subFilterBorderBottomRightRadius": 12,
    "subFilterBorderRadius": 16,
    "subFilterPaddingTop": 8,
    "subFilterPaddingRight": 16,
    "subFilterPaddingLeft": 16,
    "subFilterPaddingBottom": 16,
    "subFilterPadding": 16,
    "subFilterPaddingTypeFlag": 2,
    "lineHeightType": "px",
    "contentHasLimitRadio": "字数",
    "activeLineHeightType": "px",
    "titleLineHeightType": "px",
    "filterWidth": 400,
    "titleActiveLineHeightType": "px",
    "labelShow": true,
    "labelBoxBorderTopLeftRadius": 0,
    "labelBoxBorderTopRightRadius": 0,
    "labelBoxBorderBottomLeftRadius": 0,
    "labelBoxBorderBottomRightRadius": 0,
    "labelBoxBorderRadius": 0,
    "labelBoxPaddingTop": 0,
    "labelBoxPaddingBottom": 0,
    "labelBoxPadding": 0,
    "labelLineMargin": 10,
    "labelContentHasLimit": true,
    "labelFontFamily": "sans-serif",
    "labelFontWeight": 400,
    "labelFontStyle": "normal",
    "labelLineHeightType": "px",
    "labelWritingMode": "horizontal-tb",
    "labelTextAlign": "left",
    "labelIconPosition": "right",
    "labelBorderTopLeftRadius": 0,
    "labelBorderTopRightRadius": 0,
    "labelBorderBottomLeftRadius": 0,
    "labelBorderBottomRightRadius": 0,
    "labelBorderRadius": 0,
    "labelPaddingTop": 0,
    "labelPaddingBottom": 0,
    "labelPadding": 0,
    "subFilterBorderWidth": [1, 1, 1, 1],
    "subFilterShowBorder": false,
    "subFilterBorderTypeFlag": 1
  }
]
